// 设备检测：手机 / 平板（触摸为主、窄屏）使用手机 UI，桌面使用原有围桌 UI。
// 判定规则：窄屏（< 1024px）或移动端 UA + 支持触摸 → 视为移动端。
let cached = undefined;
function detect() {
    if (typeof window === 'undefined') {
        return false;
    }
    const narrow = window.innerWidth < 1024;
    const ua = /Android|iPhone|iPad|iPod|Mobile|Windows Phone|webOS/i.test(navigator.userAgent || '');
    const coarse = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
    return narrow || (ua && coarse) || ua;
}

export function isMobileDevice() {
    if (cached === undefined) {
        cached = detect();
    }
    return cached;
}

// 窗口尺寸变化（旋转/拖宽）时重算；返回取消订阅函数
export function watchDevice(onChange) {
    const update = () => {
        const next = detect();
        if (next !== cached) {
            cached = next;
            onChange(next);
        }
    };
    window.addEventListener('resize', update);
    window.addEventListener('orientationchange', update);
    return () => {
        window.removeEventListener('resize', update);
        window.removeEventListener('orientationchange', update);
    };
}

export function resetDeviceCache() {
    cached = undefined;
}
